import { defineFcm } from '../shared/factory';

export const FCM_NONPROFIT_ORGANIZATIONS_DATA_SOURCE = defineFcm('nonprofit_organizations_data_source')
	.asEnum(['candid', 'propublica'])
	.withDefault('candid')
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'user-service',
		context: 'Nonprofit Claim Flow',
		description: 'Specifies the data source for nonprofit organizations: either candid or propublica.',
	});
